export default "__VITE_ASSET__DtpR_xXm__"